import { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Container from "../dnd/Container";
import Draggable from "../dnd/Draggable";
import PropTypes from "prop-types";
import Lane from "./Lane";
import * as boardActions from "../actions/BoardActions";
import * as laneActions from "../actions/LaneActions";

class BoardContainer extends Component {
  state = {
    addLaneMode: false,
  };

  componentDidMount() {
    const { actions } = this.props;
    actions.loadBoard(this.props.data);
  }

  onDragStart = ({ payload }) => {
    const { handleLaneDragStart } = this.props;
    handleLaneDragStart(payload?.id);
  };

  onMoveLane = ({ lane, index, action }) => {
    let newIndex;

    if (action === "LEFT") {
      newIndex = index - 1;
    } else if (action === "RIGHT") {
      newIndex = index + 1;
    }

    const { actions, handleLaneDragEnd } = this.props;
    actions.moveLane({ oldIndex: index, newIndex: newIndex });
    handleLaneDragEnd(index, newIndex, lane);
  };

  onLaneDrop = ({ removedIndex, addedIndex, payload }) => {
    const { actions, handleLaneDragEnd } = this.props;
    if (removedIndex !== addedIndex) {
      actions.moveLane({ oldIndex: removedIndex, newIndex: addedIndex });
      handleLaneDragEnd(removedIndex, addedIndex, payload);
    }
  };
  getCardDetails = (laneId, cardIndex) => {
    return this.props.reducerData.lanes.find((lane) => lane.id === laneId).cards[cardIndex];
  };
  getLaneDetails = (index) => {
    return this.props.reducerData.lanes[index];
  };

  hideEditableLane = () => {
    this.setState({ addLaneMode: false });
  };

  showEditableLane = () => {
    this.setState({ addLaneMode: true });
  };

  addNewLane = (params) => {
    this.hideEditableLane();
    this.props.actions.addLane(params);
    this.props.onLaneAdd(params);
  };

  get groupName() {
    const { id } = this.props;
    return `TrelloBoard${id}`;
  }

  render() {
    const {
      components,
      reducerData,
      draggable,
      laneDraggable,
      laneDragClass,
      laneDropClass,
      style,
      editable,
      canAddLanes,
      laneStyle,
      isShowLaneCardForm,
      buckets,
      extraHeaderLane,
      members,
    } = this.props;

    const { addLaneMode } = this.state;
    // Stick to whitelisting attributes to segregate board and lane props
    const whitelisting = [
      "onCardMoveAcrossLanes",
      "onLaneScroll",
      "onLaneDelete",
      "onLaneUpdate",
      "onCardClick",
      "onBeforeCardDelete",
      "onCardDelete",
      "onCardAdd",
      "onCardUpdate",
      "onLaneClick",
      "laneSortFunction",
      "draggable",
      "laneDraggable",
      "cardDraggable",
      "collapsibleLanes",
      "canAddLanes",
      "hideCardDeleteIcon",
      "tagStyle",
      "handleDragStart",
      "handleDragEnd",
      "cardDragClass",
      "editLaneTitle",
      "projectId",
    ];
    let passthroughPropsV2 = {};
    whitelisting.forEach((col) => {
      passthroughPropsV2 = {
        ...passthroughPropsV2,
        [col]: this.props[col],
      };
    });
    const lanes =
      reducerData && reducerData.lanes.map((lane) => ({ id: lane.id, title: lane.title }));
    return (
      <components.BoardWrapper style={style}>
        <Container
          style={{ display: "flex" }}
          orientation="horizontal"
          onDragStart={this.onDragStart}
          dragClass={laneDragClass}
          dropClass={laneDropClass}
          onDrop={this.onLaneDrop}
          lockAxis="x"
          getChildPayload={(index) => this.getLaneDetails(index)}
          groupName={this.groupName}
        >
          {reducerData.lanes.map((lane, index) => {
            const { id, droppable, type, ...otherProps } = lane;
            const laneToRender = (
              <Lane
                listLane={lanes}
                buckets={buckets}
                isShowLaneCardForm={isShowLaneCardForm}
                onMoveLane={(value) => {
                  this.onMoveLane({ lane, index, action: value });
                }}
                key={id}
                boardId={this.groupName}
                components={components}
                id={id}
                laneType={type}
                getCardDetails={this.getCardDetails}
                index={index}
                droppable={droppable === undefined ? true : droppable}
                style={laneStyle || lane.style || {}}
                labelStyle={lane.labelStyle || {}}
                cardStyle={this.props.cardStyle || lane.cardStyle}
                editable={editable && !lane.disallowAddingCard}
                members={members}
                extraHeaderLane={() => extraHeaderLane(lane)}
                {...otherProps}
                {...passthroughPropsV2}
                currentSize={this.props.currentSize}
              />
            );
            return draggable && laneDraggable ? (
              <Draggable key={lane.id}>{laneToRender}</Draggable>
            ) : (
              laneToRender
            );
          })}
        </Container>

        {canAddLanes && (
          <Container orientation="horizontal">
            {editable && !addLaneMode ? (
              <components.NewLaneSection onClick={this.showEditableLane} />
            ) : (
              addLaneMode && (
                <components.NewLaneForm onCancel={this.hideEditableLane} onAdd={this.addNewLane} />
              )
            )}
          </Container>
        )}
      </components.BoardWrapper>
    );
  }
}

BoardContainer.propTypes = {
  id: PropTypes.string,
  components: PropTypes.object,
  actions: PropTypes.object,
  data: PropTypes.object.isRequired,
  reducerData: PropTypes.object,
  onLaneScroll: PropTypes.func,
  onCardClick: PropTypes.func,
  onBeforeCardDelete: PropTypes.func,
  onCardDelete: PropTypes.func,
  onCardAdd: PropTypes.func,
  onCardUpdate: PropTypes.func,
  onLaneAdd: PropTypes.func,
  onLaneDelete: PropTypes.func,
  onLaneClick: PropTypes.func,
  onLaneUpdate: PropTypes.func,
  laneSortFunction: PropTypes.func,
  draggable: PropTypes.bool,
  collapsibleLanes: PropTypes.bool,
  editable: PropTypes.bool,
  canAddLanes: PropTypes.bool,
  hideCardDeleteIcon: PropTypes.bool,
  handleDragStart: PropTypes.func,
  handleDragEnd: PropTypes.func,
  handleLaneDragStart: PropTypes.func,
  handleLaneDragEnd: PropTypes.func,
  style: PropTypes.object,
  tagStyle: PropTypes.object,
  laneDraggable: PropTypes.bool,
  cardDraggable: PropTypes.bool,
  cardDragClass: PropTypes.string,
  laneDragClass: PropTypes.string,
  laneDropClass: PropTypes.string,
  onCardMoveAcrossLanes: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  isShowLaneCardForm: PropTypes.bool,
  extraHeaderLane: PropTypes.func,
};

BoardContainer.defaultProps = {
  t: (v) => v,
  handleDragStart: () => {},
  handleDragEnd: () => {},
  handleLaneDragStart: () => {},
  handleLaneDragEnd: () => {},
  onCardUpdate: () => {},
  onLaneAdd: () => {},
  onLaneDelete: () => {},
  onCardMoveAcrossLanes: () => {},
  onLaneUpdate: () => {},
  editable: false,
  canAddLanes: false,
  hideCardDeleteIcon: false,
  draggable: false,
  collapsibleLanes: false,
  laneDraggable: true,
  cardDraggable: true,
  cardDragClass: "react_trello_dragClass",
  laneDragClass: "react_trello_dragLaneClass",
  laneDropClass: "",
};

const mapStateToProps = (state) => {
  return state.boardReducer.lanes ? { reducerData: state.boardReducer } : {};
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...boardActions, ...laneActions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BoardContainer);
